export default function initNumberAnimation() {
  const counters = document.querySelectorAll<HTMLElement>('[data-number]')

  function animateValue(
    el: HTMLElement,
    endValue: number,
    suffix: string = '',
    duration: number = 2500
  ): void {
    let startValue = 0
    let startTime: number | null = null

    function easeOutExpo(t: number) {
      return t === 1 ? 1 : 1 - Math.pow(2, -10 * t)
    }

    const originalString = el.dataset.number ?? String(endValue)
    const originalDecimals = originalString.includes('.') ? originalString.split('.')[1].length : 0

    const thousandFormatter = new Intl.NumberFormat('sv-SE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })

    function formatExactDecimals(value: number): string {
      const [intPart, decPart] = value.toFixed(originalDecimals).split('.')
      const formattedInt = thousandFormatter.format(parseInt(intPart))
      return decPart ? `${formattedInt},${decPart}` : formattedInt
    }

    const step = (timestamp: number) => {
      if (startTime === null) startTime = timestamp

      const rawProgress = Math.min((timestamp - startTime) / duration, 1)
      const progress = easeOutExpo(rawProgress)

      const value = startValue + (endValue - startValue) * progress

      el.textContent = formatExactDecimals(value) + suffix

      if (progress < 1) requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const container = entry.target as HTMLElement
          const animatedEl = container.querySelector<HTMLElement>('.animated-value')
          if (!animatedEl) return

          const endValue = parseFloat(container.dataset.number ?? '0')
          const suffix = container.dataset.suffix ?? ''

          animateValue(animatedEl, endValue, suffix)
          observer.unobserve(container)
        }
      })
    },
    {
      threshold: 0.8,
      rootMargin: '0px 0px -20px 0px',
    }
  )

  counters.forEach((counter) => observer.observe(counter))
}
